<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Resource Details</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <button type="submit" class="btn btn-warning btn-fill" @click="editResource">Edit Resource</button>
                </div>
            </div>
            <div class="table-responsive" v-if="resource">
                <table class="table table-bordered table-light">
                    <tr>
                        <th>Id</th>
                        <td>{{resource.newsResourcesId}}</td>
                    </tr>
                  <tr>
                    <th>Resource Type </th>
                    <td>{{getResourceType(resource.resourceType)}}</td>
                  </tr>
                    <tr>
                        <th>Header</th>
                        <td>{{resource.articleHeader}}</td>
                    </tr>
                  <tr>
                    <th>Article URL</th>
                    <td>{{resource.articleUrl}}</td>
                  </tr>
                    <tr>
                        <th>Image</th>
                      <td ><img v-if="resource.imageUrl" class="table-thumbnail" :src="resource.imageUrl" :title="resource.imageUrl" /></td>
                    </tr>
                  <tr>
                    <th>Description</th>
                    <td>{{resource.description}}</td>
                  </tr>
                    <tr>
                        <th>Video Code</th>
                        <td>{{resource.videoCode}}</td>
                    </tr>
                    <tr>
                        <th>Status</th>
                        <td v-if="resource.isActive == '0'">Inactive</td>
                        <td v-else>Active</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    import { mapGetters } from 'vuex'
    export default {
        name: 'ViewResource',
        components: {
            LTable,
        },
        created (){
        this.$store.dispatch('GETSELECTEDRESOURCE', this.$route.params.id).then(() =>{
            this.resource = this.selectedResource;
        })

    },
    data () {
        return {
          resource: {}
        }
    },
    methods: {
      getResourceType (typeId) {
        if (typeId === 1) {
          return "Featured Article"
        } else if (typeId === 2) {
          return "Set the TONE"
        } else {
          return "Advertisement"
        }
      },
        editResource(){
            this.$router.push({ name: 'EditResource', params: { id: this.resource.newsResourcesId}})
        },
    },
    computed: {...mapGetters([
        'selectedResource'])
    }
    }
</script>

<style>
    th{
        width: 180px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Resources/ResourceDetails.vue